"use client";

import { ReactNode } from "react";

import { useScrollReveal } from "@/lib/hooks/use-scroll-reveal";

import { Faq } from "./sections/faq";
import { Features } from "./sections/features";
import { FinalCta } from "./sections/final-cta";
import { HowItWorks } from "./sections/how-it-works";
import { PricingTrio } from "./sections/pricing-trio";
import { Showcase } from "./sections/showcase";

export function LandingShell({ hero }: { hero: ReactNode }) {
  useScrollReveal();

  return (
    <main>
      {hero}
      <HowItWorks />
      <Features />
      <Showcase />
      <PricingTrio />
      <Faq />
      <FinalCta />
    </main>
  );
}
